// extracted by mini-css-extract-plugin
module.exports = {"default":"styles_default__1nzaE","hide":"styles_hide__1M2q7"};